import {
  Button,
  Heading,
  HStack,
  Spacer,
  Stack,
  Text,
  useDisclosure,
} from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { EditPencilIcon } from 'components/icons';
import React from 'react';
import { Member } from 'types';
import {
  Permission,
  PermissionRuleUpdateModal,
} from './PermissionRuleUpdateModal';

export interface PermissionRuleConfig {
  allowAllMembers: boolean;
  allowedMembers: Member[];
}

interface PermissionRuleCardProps {
  userFriendlyRuleName: string;
  ruleDescription: string;
  ruleConfig?: PermissionRuleConfig;
  canUpdate?: boolean;
  isDummy?: boolean;
  graphRuleName?: Permission;
  nodeId: string;
  spaceId: string;
}

export const PermissionRuleCard = ({
  userFriendlyRuleName,
  ruleDescription,
  ruleConfig,
  canUpdate,
  isDummy,
  graphRuleName,
  nodeId,
  spaceId,
}: PermissionRuleCardProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Stack>
        <Stack spacing={1}>
          <HStack>
            <Heading size="sm">{userFriendlyRuleName}</Heading>
            <Spacer />
            {ruleConfig && (
              <ConfigOverview
                {...ruleConfig}
                isDisabled={!canUpdate && !isDummy}
                onEdit={!isDummy ? onOpen : undefined}
              />
            )}
          </HStack>
        </Stack>
        <Text fontSize="sm">{ruleDescription}</Text>
      </Stack>
      {ruleConfig && graphRuleName && (
        <PermissionRuleUpdateModal
          isOpen={isOpen}
          onClose={onClose}
          config={ruleConfig}
          graphRuleName={graphRuleName}
          nodeId={nodeId}
          spaceId={spaceId}
        />
      )}
    </>
  );
};

interface ConfigButtonProps extends PermissionRuleConfig {
  isDisabled: boolean;
  onEdit?(): void;
}
const ConfigOverview = ({
  allowAllMembers,
  allowedMembers,
  isDisabled,
  onEdit,
}: ConfigButtonProps) => {
  let text = t`Owners only`;
  let variant = 'solid';
  let colorScheme = 'green';

  if (allowAllMembers) {
    variant = 'outline';
    text = t`All members`;
    colorScheme = 'orange';
  }
  if (allowedMembers.length > 0) {
    variant = 'outline';
    text = t`Some members`;
  }

  return (
    <Button
      fontWeight="bold"
      size="xs"
      isDisabled={isDisabled}
      rightIcon={!isDisabled ? <EditPencilIcon /> : undefined}
      variant={variant}
      colorScheme={colorScheme}
      onClick={onEdit}
    >
      {text}
    </Button>
  );
};
